import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProvinces } from '../../../components/layouts/PageBase/actions';
import { fetchProducts, fetchReport } from '../../../pages/Home/actions';
import { useDebounce } from '../../../utils/hooks';
import { getRegional } from '../../../utils/storage';
import Card from '../../elements/Card';
import LoadingBars from '../../elements/LoadingBars';
import Select from '../../fields/SelectBox';
import { dataMonths, getChartOptions } from './constans';
import styles from './styles.scoped.css';

function ChartReport() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProvinces());
  }, []);

  const userRegion = getRegional();
  const {
    dataChartReport: { cities = [], data = [] },
    isLoadingChartReport,
  } = useSelector((s) => s.home);

  const { dataProvinces } = useSelector((s) => s.pageBase);

  const { dataProductCategories } = useSelector((s) => s.pageBase);

  const [currentCategory, setCurrentCategory] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth()+1);

  const [provinceId, setProvinceId] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [productId, setProductId] = useState('');
  const dataP = dataProvinces?.map(item => {
    return { value : item.value, label: item.name, region: item.region };
  });

  useEffect(() => {
    const defaultCategory = dataProductCategories.find(
      (ct) => ct.name.toLowerCase().trim() === 'lpg'
    );
    if (defaultCategory) {
      setCategoryId(defaultCategory.categoryId);
    }
  }, [dataProductCategories]);

  useEffect(() => {
    if (categoryId) {
      setProductId('');
      const _currentCategory = dataProductCategories.find(
        (ct) => ct.categoryId === categoryId
      );
      setCurrentCategory(_currentCategory);

      dispatch(fetchProducts(categoryId));
    }
  }, [categoryId]);

  const debounceFilter = useDebounce(provinceId + categoryId + productId, 200);

  useEffect(() => {
    dispatch(fetchReport(provinceId, categoryId, productId));
  }, [debounceFilter]);

  return (
    <Card className={styles.graph}>
      <div className={styles['header']}>
        <h5>Top 10</h5>
        <div className={styles['filter-wrap']}>
          <Select
            data={[
              ...dataMonths,
            ]}
            defaultValue={currentMonth}
            eventName="filter_top_10_by_product"
            hideLabel
            onChange={(event) => setCurrentMonth(event)}
            value={currentMonth}
          />
          <Select
            data={[
              { value: '', label: 'Semua Provinsi' },
              ...dataP.filter((p) =>
                userRegion ? p.regional === userRegion : true
              ),
            ]}
            defaultValue={provinceId}
            eventName="filter_top_10_by_province"
            hideLabel
            onChange={(event) => setProvinceId(event)}
            value={''}
          />
        </div>
      </div>
      {isLoadingChartReport ? (
        <div className={styles['loading-container']}>
          <LoadingBars size={10} />
        </div>
      ) : (
        <Bar
          data={{
            labels: cities,
            datasets: [
              {
                data,
                backgroundColor: 'rgba(172, 194, 58, 1)',
                hoverBackgroundColor: 'rgba(217, 234, 157, 0.8)',
              },
            ],
          }}
          options={getChartOptions(
            currentCategory?.unit_name,
            currentCategory?.unit_symbol
          )}
        />
      )}
    </Card>
  );
}

export default ChartReport;
